import { useEffect, useState } from 'react'

// This version is required by recurly-js
const RECURLY_APPLE_PAY_API_VERSION = 4

declare global {
  interface Window {
    // This only exists in safari browsers
    ApplePaySession?: any
  }
}

export const useApplePayAccess = () => {
  // const { getFeatureFlag } = useFeatureFlags()
  // const isApplePayFlagEnabled = getFeatureFlag<boolean>('subscribe-enable-apple-pay', true)
  const [isApplePaySupported, setIsApplePaySupported] = useState(false)
  const [isApplePayEnabled, setIsApplePayEnabled] = useState(false)

  useEffect(() => {
    // These checks come from the recurly-js library, we are checking them ahead of time to avoid having to respond to errors with a jittery UI
    setIsApplePaySupported(
      window && window.ApplePaySession && window.ApplePaySession.supportsVersion(RECURLY_APPLE_PAY_API_VERSION)
    )
    setIsApplePayEnabled(window && window.ApplePaySession && window.ApplePaySession.canMakePayments())
  }, [])

  return {
    isApplePaySupported,
    isApplePayEnabled,
    canShowApplePay: isApplePaySupported && isApplePayEnabled,
  }
}
